import { render } from "./ExtraNav.vue?vue&type=template&id=3f4b58dd"
import script from "./ExtraNav.vue?vue&type=script&lang=js"
export * from "./ExtraNav.vue?vue&type=script&lang=js"

import "./ExtraNav.vue?vue&type=style&index=0&id=3f4b58dd&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__